var _Defs, _Use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, Symbol as _Symbol, Circle, Path, Use, LinearGradient, Stop } from "react-native-svg";
function SvgPartlyCloudy(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(_Symbol, {
    id: "partly_cloudy_svg__c",
    viewBox: "0 0 196 196"
  }, /*#__PURE__*/React.createElement(Circle, {
    cx: 98,
    cy: 98,
    r: 40,
    stroke: "#f8af18",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    fill: "url(#partly_cloudy_svg__a)"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M98 31.38V6m0 184v-25.38m47.11-113.73L163.05 33M33 163.05l17.94-17.94m0-94.22L33 33m130.1 130.1l-17.94-17.94M6 98h25.38M190 98h-25.38",
    fill: "none",
    stroke: "#fbbf24",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 12
  })), /*#__PURE__*/React.createElement(_Symbol, {
    id: "partly_cloudy_svg__d",
    viewBox: "0 0 350 222"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M291 107c-.85 0-1.68.09-2.53.13A83.9 83.9 0 00135.6 42.92 55.91 55.91 0 0051 91a56.56 56.56 0 00.8 9.08A60 60 0 0063 219c1.35 0 2.67-.11 4-.2v.2h224a56 56 0 000-112z",
    stroke: "#959aa2",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    fill: "url(#partly_cloudy_svg__b)"
  })), /*#__PURE__*/React.createElement(_Symbol, {
    id: "partly_cloudy_svg__e",
    viewBox: "0 0 363 258"
  }, /*#__PURE__*/React.createElement(Use, {
    width: 196,
    height: 196,
    xlinkHref: "#partly_cloudy_svg__c"
  }), /*#__PURE__*/React.createElement(Use, {
    width: 350,
    height: 222,
    transform: "translate(13 36)",
    xlinkHref: "#partly_cloudy_svg__d"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "partly_cloudy_svg__b",
    x1: 99.45,
    y1: 30.68,
    x2: 232.64,
    y2: 261.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#deeafb"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "partly_cloudy_svg__a",
    x1: 78,
    y1: 63.35,
    x2: 118,
    y2: 132.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#f59e0b"
  })))), _Use || (_Use = /*#__PURE__*/React.createElement(Use, {
    width: 363,
    height: 258,
    transform: "translate(68 109)",
    xlinkHref: "#partly_cloudy_svg__e"
  })));
}
export default SvgPartlyCloudy;